<kal-card (dismissed)="closeFilters()"
          [dismissable]="true">

    <kal-card-title>
        Filtrer
    </kal-card-title>

    <kal-card-content [formGroup]="form">


        <div class="gup-C-flexGroup -row">

            <!-- Statuts -->
            <div class="gup-C-flexGroup__item -full">

                <kal-form-field>

                    <kal-select id="folder_bank_dialog_filters_status"
                                label="Statut"
                                formControlName="statusId">

                        <kal-option [value]="null">
                            Tous
                        </kal-option>

                        <kal-option *ngFor="let status of statusList"
                                    [value]="status.Id">
                            {{ status.Libelle }}
                        </kal-option>

                    </kal-select>

                </kal-form-field>

            </div>

            <!-- Date dépassée  -->
            <div class="gup-C-flexGroup__item -full">

                <kal-checkbox formControlName="hasExpired"
                              id="folder_bank_dialog_filters_has_expired"
                              label="Date dépassée">
                </kal-checkbox>

            </div>

            <!-- non lié à un article -->
            <div class="gup-C-flexGroup__item -full">

                <kal-checkbox formControlName="isUnlinked"
                              id="folder_bank_dialog_filters_is_unlinked"
                              label="Non lié à un article">
                </kal-checkbox>

            </div>

        </div>

    </kal-card-content>

    <kal-card-actions>

        <kal-button id="folder_bank_dialog_filters_apply"
                    kalTheme="primary"
                    (click)="applyFilters()">
            Appliquer
        </kal-button>

        <kal-button id="folder_bank_dialog_filters_cancel"
                    kalTheme="secondary"
                    (click)="closeFilters()">
            Annuler
        </kal-button>

    </kal-card-actions>

</kal-card>
